import {MapConfigProvider} from "base/component/geo/provider";

import {PageLayout} from "base/layout";
import {MainMapProvider} from "app/main/map/MainMapProvider";
import MainMap from "app/common/map/MainMap";
import {MainMapMenu} from "app/common/menu/MainMapMenu";

export const MapViewerPage = () => {
    return (
        <MapConfigProvider>
            <MainMapProvider config={null}>
                <PageLayout>
                    <MainMap legend={<MainMapMenu />} showMapActions={true} />
                </PageLayout>
            </MainMapProvider>
        </MapConfigProvider>
    );
};
